import { useMutation } from '@tanstack/react-query';

import { leaveApp } from '@/shared/browser/leave-app';

import { authApi } from '../api/auth-api';

/** Asks for Google's authorisation URL and leaves for it; 409 means Google is not set up. */
export function useGoogleStart() {
  return useMutation({
    mutationFn: authApi.googleStart,
    meta: { silentError: true },
    onSuccess: ({ url }) => leaveApp(url),
  });
}
